import React from 'react';
import PropTypes from 'prop-types';
import { StyledSelect } from './MealsSelect.style';
import { mealTypesToDisplay } from 'types/meals';
import { injectIntl, intlShape } from 'react-intl';

const MealsSelect = ({ meals, defaultValue, className, selectMeal, firstName, lastName, id, disabled, intl }) => (
  <StyledSelect
    className={`${className} meal-select`}
    id={`meal-select-${id}`}
    disabled={disabled}
    defaultValue={defaultValue}
    onChange={(e) => selectMeal(e, firstName, lastName, id)}
  >
    {meals.map(({ code }) => (
      <option key={code} value={code} selected={code === defaultValue}>
        {intl.formatMessage({ id: `mealTypes.${mealTypesToDisplay[code]}` })}
      </option>
    ))}
  </StyledSelect>
);

MealsSelect.propTypes = {
  defaultValue: PropTypes.string,
  meals: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
      name: PropTypes.string
    })
  ),
  className: PropTypes.string,
  selectMeal: PropTypes.func,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  id: PropTypes.string,
  disabled: PropTypes.bool,
  intl: intlShape
};

export default injectIntl(MealsSelect);
